import { render, staticRenderFns } from "./OfficeSummary.vue?vue&type=template&id=5492ca20&"
import script from "./OfficeSummary.vue?vue&type=script&lang=js&"
export * from "./OfficeSummary.vue?vue&type=script&lang=js&"
import style0 from "./OfficeSummary.vue?vue&type=style&index=0&id=5492ca20&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports